import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons, popperPlacements, services } from '@/utils'

import button from '@/components/button'
import rulePrices from '@/components/services/tariffs/rules/rule/prices'

function renderActionsMenuActivator(h) {
  let activatorColor
  if (this.proxy.action === 'decrease') {
    activatorColor = Colors.error
  } else {
    activatorColor = Colors.success
  }

  return h(
    button,
    {
      props: {
        label: this.getTranslate(`${services.tariffs}.actions.${this.proxy.action}`),
        mode: buttonModes.flat,
        color: activatorColor
      },
      slot: 'activator'
    }
  )
}
function renderActionsItem(h, action) {
  let actionIcon
  let actionColor
  if (action === 'decrease') {
    actionIcon = icons.add
    actionColor = Colors.error
  } else {
    actionIcon = icons.remove
    actionColor = Colors.success
  }

  return h(
    components['list-item'],
    {
      props: {
        icon: actionIcon,
        color: actionColor,
        label: this.getTranslate(`${services.tariffs}.actions.${action}`),
        dense: true
      },
      on: {
        click: () => {
          this.proxy.action = action
        }
      }
    }
  )
}
function renderActionsList(h) {
  return h(
    components.list,
    {
      props: {
        dense: true,
        rounded: true
      }
    },
    [ 'decrease', 'increase' ].map(action => {
      return renderActionsItem.call(this, h, action)
    })
  )
}
function renderActionsMenu(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements['bottom-start']
      }
    },
    [
      renderActionsMenuActivator.call(this, h),
      renderActionsList.call(this, h)
    ]
  )
}
function renderRulePrices(h) {
  return h(
    rulePrices,
    {
      props: {
        value: this.proxy.price,
        source: this.source
      },
      on: {
        input: event => {
          this.updatePrice(event)
        }
      }
    }
  )
}
export default function(h) {
  return h(
    'div',
    {
      class: `${services.tariffs}-rule__actions`
    },
    [
      renderActionsMenu.call(this, h),
      renderRulePrices.call(this, h)
    ]
  )
}
